import React from 'react';
import { withApollo, graphql, compose } from 'react-apollo';
import Grid from '@material-ui/core/Grid';
import _get from 'lodash/get';

import gqlQueryListAuditLogs from 'graphql/queries/list-audit-logs';
import AuditLogListGrid from 'components/audit-logs/audit-log-list-grid';
import PageHeader from 'components/page-header';
import Content from 'components/theme/content';
import withGraphqlLoaderHOC from 'components/theme/loader/with-graphql-loader-hoc';
import dateUtil from 'utils/date';

function AuditLogs(props) {
  const auditLogs = _get(props, 'data.queryListAuditLogs', []);

  return (
    <>
      <PageHeader title="Audit Logs" />
      <Content>
        <Grid container>
          <Grid item xs={12}>
            <AuditLogListGrid auditLogs={auditLogs} />
          </Grid>
        </Grid>
      </Content>
    </>
  );
}

const AuditLogsWithGraphqlLoader = withGraphqlLoaderHOC(AuditLogs, [
  { name: 'queryListAuditLogs', data: 'listAuditLogs.items' }
]);

const AuditLogComponent = compose(
  graphql(gqlQueryListAuditLogs, {
    name: 'queryListAuditLogs',
    options: () => ({
      variables: {
        startTime: dateUtil.monthAgoFmt(),
        endTime: dateUtil.tomorrowFmt(),
        limit: 100
      }
    })
  })
)(AuditLogsWithGraphqlLoader);

export default withApollo(AuditLogComponent);
